export const workbookXMLRel = `<Relationship Id="rId{index}" Target="worksheets/sheet{index}.xml" Type="http://schemas.openxmlformats.org/officeDocument/2006/relationships/worksheet"/>`;
